import React, { useContext } from 'react';
import { BillingInvoicesPageContext } from '../BillingInvoicesPageContext';
import { FormStatus } from './FormStatus';

const BillingProfileErrorStatus: React.FC = () => {
  const { fetchProfileError } = useContext(BillingInvoicesPageContext);

  if (!fetchProfileError) return null;

  return <FormStatus status="error" text={fetchProfileError.message} />;
};

export default BillingProfileErrorStatus;
